var RNSVG = require('react-native-svg');

exports._svg = RNSVG.Svg;

exports._path = RNSVG.Path;
exports._rect = RNSVG.Rect;
